module.exports = __webpack_public_path__ + "img/news-1.47cb4867.jpg";